import React, { lazy } from 'react';

import { RouteObject } from 'react-router-dom';

const DataPrivacy = lazy(() => import('@pages/landing/DataPrivacy'));

export const DataPrivacyRoutes: RouteObject[] = [
  {
    path: '/data-privacy',
    element: (
      <React.Suspense>
        <DataPrivacy />
      </React.Suspense>
    ),
  },
];
